import { HeadSnowflakeOutlineIcon } from './HeadSnowflakeOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C7A97A26-B7C3-406A-9087-2463AC624926
 * name head-snowflake-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-snowflake-outline.svg
 * tags
 */
export const BrainFreezeOutlineIcon = HeadSnowflakeOutlineIcon;
export default BrainFreezeOutlineIcon